<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Grupo</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <app-city-solution-combobox
              :municipioSolucao="payload"
              :firstLoad="true"
            ></app-city-solution-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { groupAPI } from "../GroupAPI";
import AppCitySolutionCombobox from "@/modules/solution/components/city/ComboboxSolucao";
import { citySolutionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertGroup",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    municipioId: { required: true },
  },
  components: {
    AppCitySolutionCombobox,
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin", "isAT"]),
  },
  data() {
    return {
      payload: {
        solutions: [],
      },
      dialog: false,
    };
  },
  watch: {
    dialog() {
      if (this.object && this.edit === true) {
        let solutions = this.payload.solutions;
        this.payload = this.object;

        this.payload.solutions = solutions;
      }
    },
  },

  methods: {
    onConfirm() {
      this.payload.municipioId = this.municipioId;

      if (this.edit === true) {
        groupAPI
          .update(this.payload)
          .then((resp) => {
            this.dialog = false;
            this.$emit("on-save");
          })
          .catch();
      } else {
        groupAPI
          .create(this.payload)
          .then((resp) => {
            this.dialog = false;
            this.$emit("on-save");
          })
          .catch();
      }

      this.payload = {};
    },
    loadSolutions() {
      citySolutionAPI
        .listByCity({ municipioId: this.$route.params.id })
        .then((resp) => {
          this.payload.solutions = resp.data;
        })
        .catch((resp) => {
          this.$notification.error(
            `Erro ao listar ${this.isAT ? "Iniciativas" : "Soluções"}`
          );
        });
    },
  },
};
</script>
